import {MatStepperIntl} from "@angular/material/stepper";
import {Injectable} from "@angular/core";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GjeldendeLokale} from "felles-ng2/tjenester/i18n/GjeldendeLokale";

/**
 * Stepper i material - dersom optional step vises så overstyrer denne "Optional Label".
 *
 * Se https://material.angular.io/components/stepper/overview
 */
@Injectable()
export class MatStepperOversettelse extends MatStepperIntl {

    constructor(private oversettelser: Oversettelser, gjeldendeLokale:GjeldendeLokale){
        super();
        gjeldendeLokale.brukersLokaleSomStrøm().subscribe(()=>this.oppdaterOptionalLabel())
    }

    oppdaterOptionalLabel() {
        this.optionalLabel = this.oversettelser.oversett(i18n('Valgfritt'));
        // Required for the optional label text to be updated
        // Notifies the MatStepperIntl service that a change has been made
        this.changes.next();
    }
}
